module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "id": "aut",
      "title": "Author’s Note"
    }
  }, [_c('h1', {
    staticClass: "aut_h"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xv",
      "title": "xv"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062878823_Contents#raut"
    }
  }, [_vm._v("Author’s Note")])])]), _vm._v(" "), _c('div', {
    staticClass: "top3"
  }, [_c('p', {
    staticClass: "nonindent_wos"
  }, [_vm._v("This book is based primarily on interviews I conducted with and materials I received from nearly two hundred people: past and present Deutsche Bank employees, from the highest-ranking executives and board members to low-level staff; their family members, friends, lawyers, and rivals; consultants and contractors who worked at the bank; current and former regulators, prosecutors, and other government officials; and others with direct knowledge of the events described in the book. Some of these people shared emails, letters, photos, bank documents, audio and video recordings, and other primary-source materials. Most agreed to help me on the condition that I not identify them as sources. When faced with conflicting accounts of specific incidents, I have used the descriptions that strike me as the most plausible, based on factors including the credibility of different sources. In some cases, I have included dissenting accounts in footnotes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent_wos"
  }, [_vm._v("I also drew on decades of journalism and academic research—as well as court filings, government documents, bank archives, and recordings and transcripts of conversations—about Deutsche Bank, the banking industry, and the book’s characters. Those sources are detailed at the end of the book."), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xvi",
      "title": "xvi"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-624a9cc4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062878823_Authors_Note.vue
// module id = 66
// module chunks = 0